import { render, staticRenderFns } from "./ActiveCompanyPill.vue?vue&type=template&id=5c28ef7a&scoped=true&"
import script from "./ActiveCompanyPill.vue?vue&type=script&lang=js&"
export * from "./ActiveCompanyPill.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCompanyPill.vue?vue&type=style&index=0&id=5c28ef7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28ef7a",
  null
  
)

export default component.exports